import { render } from "./Articles.vue?vue&type=template&id=1fd42afe"
const script = {}
script.render = render

export default script